@if (loading$ | async) {
  <div class="loading-state">
    <nb-spinner></nb-spinner>
  </div>
}

@if (!(loading$ | async)) {
  <div class="page-container">

    <!-- Sticky header -->
    <div class="sticky-header">
      <button nbButton ghost status="basic" (click)="navigateBack()">
        <nb-icon icon="arrow-back-outline" pack="eva"></nb-icon>
      </button>

      <div class="header-content">
        <span class="header-title">Neues Protokoll</span>
        <div class="header-badges">
          @if (protocolType()) {
            <span class="type-badge" [ngStyle]="typeBadgeStyle(protocolType()!.color)">
              <span class="badge-dot" [style.background]="protocolType()!.color"></span>
              <span class="badge-shortcut">{{ protocolType()!.shortcut }}</span>
              <span class="badge-sep">·</span>
              <span class="badge-name">{{ protocolType()!.name }}</span>
            </span>
          }
          @if (building()) {
            <span class="entity-chip">
              <nb-icon icon="home-outline" pack="eva"></nb-icon>
              {{ building()!.baseData.sectionText }}
            </span>
          }
        </div>
      </div>

      <div class="header-actions">
        <button nbButton ghost size="small" nbTooltip="Alle ausklappen" (click)="expandAll()">
          <nb-icon icon="expand-outline" pack="eva"></nb-icon>
        </button>
        <button nbButton ghost size="small" nbTooltip="Alle einklappen" (click)="collapseAll()">
          <nb-icon icon="collapse-outline" pack="eva"></nb-icon>
        </button>
        <button nbButton status="primary" size="small" (click)="submit()" [disabled]="saving$ | async">
          <nb-icon icon="checkmark-outline" pack="eva"></nb-icon>
          Erstellen und archivieren
        </button>
      </div>
    </div>

    <!-- Form sections -->
    <div class="sections">
      @for (section of sections(); track $index; let i = $index) {
        <div class="section-card">
          <div class="section-header" (click)="toggleExpand(i)"
               [style.background]="getHeaderBg(section.collection.color)">
            <div class="section-header-left">
              <span class="section-title">{{ section.collection.title }}</span>
              @if (hasRequiredFields(section)) {
                <span class="required-badge">
                  <nb-icon icon="alert-circle-outline" pack="eva"></nb-icon>
                  Pflichtfelder
                </span>
              }
            </div>
            <nb-icon [icon]="section.expanded ? 'chevron-up-outline' : 'chevron-down-outline'" pack="eva"></nb-icon>
          </div>
          <div class="section-body" [hidden]="!section.expanded">
            @if (section.collection.description) {
              <p class="description">
                {{ section.collection.description }}
              </p>
            }
            <wr-custom-form [collection]="section.collection" [readonly]="false"></wr-custom-form>
          </div>
        </div>
      } @empty {
        <div class="empty-state">
          <p>Für diesen Protokolltyp sind keine Feldgruppen konfiguriert.</p>
          <button nbButton status="primary" (click)="submit()" [disabled]="saving$ | async">
            Leeres Protokoll erstellen und archivieren
          </button>
        </div>
      }
    </div>

  </div>
}
